const googleApiKey = {
    key: 'AIzaSyC_xaQKyjDu1jXVBTcpI5pGCYVZGzBf6XE'
}

export default googleApiKey;